module.exports = __webpack_public_path__ + "img/worksbot_img19112506.7aa78915.jpg";